import { get } from '@/api/request'
import request from '@/api/request'

/**
 * 分页查询所有反馈
 * @param {object} params - 查询参数
 * @param {number} [params.type] - 反馈类型：1-功能建议，2-系统问题，3-内容错误，4-其他
 * @param {number} [params.status] - 反馈状态：0-待处理，1-已处理
 * @param {number} [params.page=1] - 当前页码
 * @param {number} [params.size=20] - 每页大小
 */
export function getFeedbackList(params) {
  return get('/app/admin/feedback/list', params)
}

/**
 * 获取反馈详情
 * @param {number} id - 反馈ID
 */
export function getFeedbackDetail(id) {
  return get(`/app/admin/feedback/${id}`)
}

/**
 * 标记反馈为已处理
 * @param {number} id - 反馈ID
 */
export function processFeedback(id) {
  return request.put(`/app/admin/feedback/${id}/process`)
}
